module.exports = __webpack_public_path__ + "img/b3.1e4c43a3.png";